export default __webpack_public_path__ + "static/media/PhoneFull.af3ce124.png";